import { Routes } from '@angular/router';
import { ownerGuard } from './core/guards/owner.guard';
import { adminGuard } from './core/guards/admin.guard';
import { licenseGuard } from './core/guards/license.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'setup',
    loadComponent: () => import('./features/setup/setup.component').then(m => m.SetupComponent)
  },

  {
    path: 'setup-account',
    loadComponent: () => import('./features/auth/setup-account/setup-account.component').then(m => m.SetupAccountComponent)
  },
  {
    path: 'owner',
    canActivate: [ownerGuard, licenseGuard],
    loadChildren: () => import('./features/owner/owner.routes').then(m => m.OWNER_ROUTES)
  },
  {
    path: 'license',
    children: [
      {
        path: 'activate',
        loadComponent: () => import('./features/license/license-activation.component').then(m => m.LicenseActivationComponent)
      },
      {
        path: 'expired',
        loadComponent: () => import('./features/license/license-expired.component').then(m => m.LicenseExpiredComponent)
      }
    ]
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'cafe/:slug',
    loadChildren: () => import('./features/customer/customer.routes').then(m => m.CUSTOMER_ROUTES)
  },
  {
    path: 'legal',
    loadChildren: () => import('./features/legal/legal.routes').then(m => m.LEGAL_ROUTES)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
